/* eslint-disable no-console */
import {
  setUser as setSentryUser,
  setExtra as setSentryExtra,
  addBreadcrumb as addSentryBreadcrumb,
} from '@sentry/react';

export function reportSessionId(sessionId: string) {
  if (import.meta.env.DEV) {
    console.log(`Session ID: ${sessionId}`);
  }

  setSentryExtra('sessionId', sessionId);
}

export function reportUserId(userId: string | null) {
  if (import.meta.env.DEV) {
    console.log(`User ID: ${userId}`);
  }

  if (import.meta.env.PROD) {
    try {
      setSentryUser(userId ? { id: userId } : null);
    } catch {}
  }
}

export function reportEvent({
  name,
  props,
}: {
  name: string;
  props?: Record<string, string | number | boolean | null>;
}) {
  if (import.meta.env.DEV) {
    console.log(`Event: ${name}(${JSON.stringify(props)})`);
  }

  if (import.meta.env.PROD) {
    try {
      addSentryBreadcrumb({ type: name, data: props });
    } catch {}
  }
}
